import React from 'react';
import type { InCartProduct } from '@apps/registry/common/components/ShoppingCart';
import { InCartItem, EmptyCart } from './components';

interface InCartSectionProps
  extends Readonly<{
    inCartProductList: Array<InCartProduct>;
    inCartProductCount: number;
    inCartProductTotal: number;
    registryCurrencyCode?: string;
  }> {}

export const InCartSection: React.FC<InCartSectionProps> = ({ inCartProductList }) => {
  return inCartProductList.length > 0 ? (
    <>
      {inCartProductList.map(product => (
        <InCartItem
          key={product.registryItemId}
          inCartProduct={product}
        />
      ))}
    </>
  ) : (
    <EmptyCart />
  );
};
